import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ClinicContext = createContext();

export const useClinic = () => {
  const context = useContext(ClinicContext);
  if (!context) {
    throw new Error('useClinic must be used within a ClinicProvider');
  }
  return context;
};

export const ClinicProvider = ({ children }) => {
  const [clinicInfo, setClinicInfo] = useState({
    clinic_name: 'EasyAI Dental Center',
    logo_url: null,
    favicon_url: null,
    letterhead_url: null,
    address: '',
    phone: '',
    email: '',
    website: '',
    business_hours: {},
    loading: true
  });

  useEffect(() => {
    fetchClinicInfo();
  }, []);

  useEffect(() => {
    // Update favicon when clinic info is loaded
    if (clinicInfo.favicon_url) {
      updateFavicon(clinicInfo.favicon_url);
    } else if (clinicInfo.logo_url) {
      // Use logo as fallback for favicon
      updateFavicon(clinicInfo.logo_url);
    }
  }, [clinicInfo.favicon_url, clinicInfo.logo_url]);

  const updateFavicon = (iconUrl) => {
    // Get existing favicon element
    let favicon = document.querySelector('link[rel="icon"]');
    
    // If no favicon element exists, create one
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    
    // Update favicon URL
    favicon.href = iconUrl;
  };

  const fetchClinicInfo = async () => {
    try {
      // Use a different endpoint that doesn't require authentication
      const response = await axios.get('/api/public/clinic-info');
      
      // Parse business_hours JSON if it's a string
      let businessHours = response.data.business_hours;
      if (typeof businessHours === 'string') {
        businessHours = JSON.parse(businessHours);
      }
      
      setClinicInfo({
        ...response.data,
        business_hours: businessHours || {},
        loading: false
      });
    } catch (error) {
      console.error('Error fetching clinic info:', error);
      // On error, keep using the default values but mark as not loading
      setClinicInfo(prev => ({ ...prev, loading: false }));
    }
  };

  const value = { ...clinicInfo, refreshClinicInfo: fetchClinicInfo };

  return (
    <ClinicContext.Provider value={value}>
      {children}
    </ClinicContext.Provider>
  );
};